module.exports = __webpack_public_path__ + "img/op_home-personas-3.3ff71f4.jpg";